import styled from 'styled-components';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { FdrTextBlock } from '@hotelplan/fdr.regular.basis.fdr-text-block';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

export const FdrAgencyHeroWrapper = styled.div({
  '.hero-wrapper': {
    img: {
      objectPosition: `center`,
    },
  },
  '.text-block-title': {
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
  },
  '.text-block-text': {
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)',
  },
});

export const FdrAgencyTextBlock = styled(FdrTextBlock)(
  ({ theme: { fontSizes } }) => ({
    '.text-block-text': {
      fontSize: fontSizes[2],
    },
  })
);

export const FdrAgencyContactModuleWrapper = styled.div(
  sx2CssThemeFn({
    border: ['16px solid', '20px solid'],
    borderColor: ['redWeb', 'redWeb'],
    backgroundColor: 'roseFine',
    padding: '50px 0',
  })
);

export const FdrAgencyContactHeadings = styled.div(
  sx2CssThemeFn({
    maxWidth: '1218px',
    margin: ['inherit', '0 auto'],
    '.contacts-flagline': {
      fontSize: '15px',
      lineHeight: '20px',
      mb: 4,
    },
    '.contacts-name': {
      fontSize: [7, '46px'],
      lineHeight: ['42px', '60px'],
      mb: 6,
      fontWeight: 800,
    },
  })
);

export const FdrAgencyContactContentBlock = styled.div<{ withImage: boolean }>(
  ({ withImage }) =>
    sx2CssThemeFn({
      display: 'flex',
      justifyContent: withImage ? 'flex-start' : '',
      alignItems: 'flex-start',
      flexDirection: 'row',
      flexWrap: 'wrap',
      maxWidth: '1218px',
      margin: ['inherit', '0 auto'],
      gap: withImage ? [6, 7] : ['30px', '110px'],
    })
);

export const FdrAgencyImage = styled.div(
  sx2CssThemeFn({
    maxWidth: '375px',
    width: '100%',
    height: '100%',
    '.agency-image': {
      borderRadius: 'unset',
    },
  })
);

export const FdrAgencyIconsBlock = styled.div<{ withImage: boolean }>(
  ({ withImage }) =>
    sx2CssThemeFn({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: [6, '40px'],
      maxWidth: ['500px', `${withImage ? '325px' : '675px'}`],
      '.agency-icon-row': {
        display: 'flex',
        alignItems: 'center',
        '.agency-icon-text': {
          minWidth: ['170px', '200px'],
          paddingLeft: 3,
          fontSize: [1, 3],
          lineHeight: 1.2,
        },
        '&.small': {
          '.agency-icon-text': {
            pl: 1,
          },
        },
      },
      'a:hover': {
        color: 'inherit',
      },
    })
);

export const FdrAgencyContactIcon = styled(BsIcon)<{ variant: string }>(
  ({ variant }) =>
    sx2CssThemeFn({
      width: variant === 'small' ? ['20px', '24px'] : ['32px', '48px'],
      height: variant === 'small' ? ['20px', '24px'] : ['32px', '48px'],
      color: variant === 'small' ? 'black' : 'redWeb',
      fill: 'transparent',
      '.icon': {
        display: 'block',
        width: '100%',
        height: '100%',
      },
    })
);

export const FdrAgencyScheduleWrapper = styled.div(({ theme: { media } }) =>
  sx2CssThemeFn({
    fontSize: [1, 3],
    [media.tablet]: {
      paddingLeft: 4,
    },
    '.agency-schedule': {
      m: 0,
      mb: 1,
    },
    pl: [4, 0],
  })
);
